import { formatFileSize, quotationFileError } from '../utils/partRequestPurchase'

export default function QuotationField({
  file,
  existing,
  removed,
  onFile,
  onRemove,
  onRestore,
}) {
  const error = quotationFileError(file)
  return (
    <div className="field">
      <span>견적서 첨부</span>
      <input
        className="input"
        type="file"
        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
        onChange={(event) => {
          onFile(event.target.files?.[0] || null)
          event.target.value = ''
        }}
      />
      <p className="muted">PDF, JPG, PNG · 10MB 이하 · 구매처 링크가 없으면 필수</p>
      {file ? (
        <p className="quotation-file">
          <span>{file.name}</span>
          <span>{formatFileSize(file.size)}</span>
          <button type="button" className="btn btn--small" onClick={() => onFile(null)}>선택 취소</button>
        </p>
      ) : null}
      {existing && !file ? (
        removed ? (
          <p className="quotation-file">
            <span>저장하면 기존 견적서를 제거합니다.</span>
            <button type="button" className="btn btn--small" onClick={onRestore}>되돌리기</button>
          </p>
        ) : (
          <p className="quotation-file">
            <span>{existing.fileName}</span>
            <span>{formatFileSize(existing.fileSize)}</span>
            <button type="button" className="btn btn--small" onClick={onRemove}>제거</button>
          </p>
        )
      ) : null}
      {error ? <p className="form-error">{error}</p> : null}
    </div>
  )
}
